import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useAuth } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { useAvailableReleaseLabels } from "@/queries";

export const useReleaseLabelDialogState = (isOpen: boolean) => {
  const [selectedReleaseLabel, setSelectedReleaseLabel] = useState("");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [selectedRegistryIds, setSelectedRegistryIds] = useState<number[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [selectedRegistry, setSelectedRegistry] = useState<any>(null);

  const { workspaceId } = useParams();
  const authContext = useAuth();
  const userContext = useUser();
  const { userToken } = authContext!;

  const { data: promptLabels } = useAvailableReleaseLabels(
    userToken!,
    userContext.activeWorkspaceId!,
  );

  useEffect(() => {
    if (!isOpen) {
      setSelectedReleaseLabel("");
      setSelectedRegistryIds([]);
      setSelectedRegistry(null);
      setErrorMessage(null);
    }
  }, [isOpen]);

  const availableReleaseLabelsList = [...(promptLabels?.available_prompt_label_names || [])].sort();

  const handleReleaseLabelSelect = (releaseLabel: string) => {
    setSelectedReleaseLabel(releaseLabel);
    setSelectedRegistryIds([]);
    setSelectedRegistry(null);
    setErrorMessage(null);
  };

  const handleAddRegistry = () => {
    if (selectedRegistry && !selectedRegistryIds.includes(selectedRegistry.id)) {
      setSelectedRegistryIds(prev => [...prev, selectedRegistry.id]);
      setSelectedRegistry(null);
    }
  };

  const handleRemoveRegistry = (id: number) => {
    setSelectedRegistryIds(prev => prev.filter(item => item !== id));
  };

  return {
    selectedReleaseLabel,
    errorMessage,
    selectedRegistryIds,
    selectedRegistry,
    availableReleaseLabelsList,
    workspaceId,
    userToken,
    userContext,
    setSelectedRegistry,
    setErrorMessage,
    handleReleaseLabelSelect,
    handleAddRegistry,
    handleRemoveRegistry,
  };
};
